import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, Subject, from } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { Firestore, collection, collectionData, doc, addDoc, updateDoc, deleteDoc, query, orderBy } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  private orders: any[] = [];
  private ordersSubject = new Subject<any[]>();
  public orders$: Observable<any[]> = this.ordersSubject.asObservable();

  private audio = new Audio('assets/notification-sound.mp3');

  constructor(private http: HttpClient) {}
  private firestore = inject(Firestore);

  getOrders(userId: string, appId: string): Observable<any[]> {
    const ordersRef = collection(this.firestore, `Users/${userId}/Apps/${appId}/Orders`);
    const ordersQuery = query(ordersRef, orderBy('timestamp', 'desc'));
    return collectionData(ordersQuery, { idField: 'id' });
  }

  addOrder(order: any): Observable<any> {
    order.timestamp = new Date();
    const ordersRef = collection(this.firestore, 'orders');
    return from(addDoc(ordersRef, order));
  }

  private playNotificationSound() {
    this.audio.play().catch(error => console.error('Error playing sound:', error));
  }

  confirmOrder(data: any) {
    return this.http.post(environment.apiUrl + 'auth/change/order/status/', data);
  }

  private convertTimestamp(timestamp: any): Date {
    if (timestamp && typeof timestamp.toDate === 'function') {
      return timestamp.toDate();
    }
    return new Date(timestamp);
  }

  updateOrderStatus(orderId: string, newStatus: string): Promise<void> {
    console.log(`Updating Firebase for order ${orderId} with status: ${newStatus}`);
    const orderDoc = doc(this.firestore, `orders/${orderId}`);
    return updateDoc(orderDoc, { status: newStatus })
      .then(() => {
        console.log(`Order ${orderId} status updated in Firebase to ${newStatus}`);
      })
      .catch((error) => {
        console.error('Error updating order status in Firebase:', error);
        throw error;
      });
  }

  deleteOrderFromFirebase(orderId: string) {
    console.log(`Deleting order ${orderId} from Firebase`);
    const orderDoc = doc(this.firestore, `orders/${orderId}`);
    return deleteDoc(orderDoc)
      .then(() => {
        console.log(`Order ${orderId} successfully deleted from Firebase`);
      })
      .catch((error) => {
        console.error(`Error deleting order ${orderId} from Firebase:`, error);
        throw error;
      });
  }

  saveArcive(data: any){
    return this.http.post(environment.apiUrl + "auth/save/order", data);
  }
}